import { render, staticRenderFns } from "./VisitDamagesViewPanel.vue?vue&type=template&id=4840344a&scoped=true&"
import script from "./VisitDamagesViewPanel.vue?vue&type=script&lang=js&"
export * from "./VisitDamagesViewPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4840344a",
  null
  
)

export default component.exports